import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/wage-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/WageForm';
import { IWage } from 'src/types/wage';
import { QueryParams } from '../../../../../../types/grid';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';
import Router from '../../../../../../navigation/router';

export interface StateProps {
    inProgress: boolean;
    inProgressProvider: boolean;
    providers: SelectObject[];
    providerSelect?: string | number | undefined;
    wage: IWage | null;
}

export interface DispatchProps {
    getProviders: (params: QueryParams) => void;
    getData: (id: string) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const WageEditScreen: FC<Props> = (props: Props) => {
    const {
        wage,
        providers,
        inProgress,
        providerSelect,
        getProviders,
        inProgressProvider,
        match: {
            params: { id },
        },
        getData,
    } = props;

    useEffect(() => {
        if (!wage || wage.id !== id) {
            getData(`${id}`);
        }
        getProviders({});
        // eslint-disable-next-line
    }, [getData, id]);

    if (!wage || inProgress) {
        return <Loader />;
    }
    let descSalary = '';
    if (providerSelect) {
        providers.forEach((it: any) => {
            if (+it.value === +providerSelect) {
                descSalary = it.annualSalary ? `${it.annualSalary}` : '';
            }
        });
    }

    if (descSalary) {
        descSalary = `Provider gets in average $${+descSalary / 12} per month`;
    }
    const providerData: any = {};
    if (wage.provider?.id && providers.length) {
        providerData.providerDropDown = { value: wage.provider.id };
    }
    return (
        <RoleLayout>
            <Breadcrumbs
                noGenerate={true}
                items={[
                    { name: 'FIXED SALARY', path: Router.generate(routes.WAGES_LIST, { param: '' }) },
                    { name: `EDIT`, path: '' },
                ]}
            />
            <div className={classNames(styles.editWrap)}>
                {inProgress || inProgressProvider ? <Loader /> : null}
                <Form
                    descSalary={descSalary}
                    providerSelect={providerSelect}
                    providers={providers}
                    initialValues={{
                        ...wage,
                        ...providerData,
                    }}
                />
            </div>
        </RoleLayout>
    );
};
export default WageEditScreen;
